import React, { useEffect, useState } from 'react'
import { Badge } from 'antd'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import { useInventory, useShift, useLatestPathname } from '../../modules'

import Prescriptions from './Prescriptions'
import Patients from './Patients'

const storeName = "Pharmacy"

let menu = [
    {
        path: 'prescriptions',
        title: 'Prescriptions',
        component: Prescriptions
    },
    {
        path: 'patients',
        title: 'Patients',
        component: Patients
    }
]

const Pharmacy = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Inventory, store, requests] = useInventory(storeName)

    useShift('Pharmacy')

    useEffect(() => {
        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[2] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory requireShift path={ path } storeName={ storeName } />
            }

        const target = `/app/pharmacy/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [store, user])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Pharmacy</p>
                <SideMenu namespace="pharmacy" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="pharmacy" menu={ menu } />
            </div>
        </div>
    )
}

export default Pharmacy